<template>
  <ul class="nav nav-main flex-column">
    <li class="nav-item">
      <router-link class="nav-link" :to="{ name: 'home' }">
        <IconHome/>
        <span>Home</span>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link class="nav-link" to="/amp">
        <IconBolt/>
        <span>AMP</span>
      </router-link>
    </li>
    <transition name="only-fade-in" mode="out-in">
      <div v-if="path.startsWith('/amp')" class="mb-2">
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_general' }">General</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_products' }">Products</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_collections' }">Collections</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_blog_posts' }">Blog posts</router-link>
        </li>
        <li class="nav-item">
          <div class="nav-link nav-link-child nav-link-divider">
            <span></span>
          </div>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_ads' }">Ads</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_reviews' }">Reviews</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_sitemap' }">Sitemap</router-link>
        </li>
        <li class="nav-item">
          <a href="https://preview.superchargify.com/" rel="noopener" target="_blank" class="nav-link nav-link-child">Preview</a>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_custom_css' }">Custom CSS</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_social' }">Social</router-link>
        </li>
        <li class="nav-item">
          <div class="nav-link nav-link-child nav-link-divider">
            <span></span>
          </div>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'amp_settings' }">Settings</router-link>
        </li>
      </div>
    </transition>
    <li class="nav-item">
      <router-link class="nav-link" to="/analytics">
        <IconClickTarget/>
        <span>Analytics</span>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link class="nav-link" to="/errorMonitoring">
        <IconBug/>
        <span>Error Monitoring</span>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link class="nav-link" to="/reports">
        <IconChart/>
        <span>Reports</span>
      </router-link>
    </li>
    <transition name="only-fade-in" mode="out-in">
      <div v-if="path.startsWith('/reports')" class="mb-2">
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'reports_health' }">Health</router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'reports_page_speed' }">PageSpeed</router-link>
        </li> -->
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'reports_sales_analytics' }">Sales &amp; Analytics</router-link>
        </li>
      </div>
    </transition>
    <li class="nav-item">
      <router-link class="nav-link" to="/account">
        <IconUser/>
        <span>Account</span>
      </router-link>
    </li>
    <transition name="only-fade-in" mode="out-in">
      <div v-if="path.startsWith('/account')" class="mb-2">
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'account_overview' }">Overview</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link nav-link-child" :to="{ name: 'account_plan' }">Plan</router-link>
        </li>
      </div>
    </transition>
    <li class="nav-item">
      <router-link class="nav-link" to="/uninstall">
        <IconCloseCircle/>
        <span>Uninstall</span>
      </router-link>
    </li>
    <li class="nav-item">
      <router-link class="nav-link" to="/help">
        <IconBuoy/>
        <span>Help &amp; Support</span>
      </router-link>
    </li>
    <li class="nav-item" v-if="vKraken">
      <router-link class="nav-link" :to="{ name: 'kraken' }">
        <IconStar/>
        <span>Kraken</span>
      </router-link>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="/logout">
        <IconDoorExit/>
        <span>Logout</span>
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState([ 'vKraken' ]),
    path: function () {
      return this.$route.path
    }
  }
}
</script>
